// SrcVer: $Id: //trak/main/adhocs/T2023/6/CLRS25/internal/web/system/common/config/material.js#1 $
'use strict';

angular.module('tcApp')
.config(function($mdGestureProvider, $animateProvider) {
	// For mobile devices without jQuery loaded, do not
	// intercept click events during the capture phase.
	// This fixes problem with clicking on "Enter" button on IOS
	$mdGestureProvider.skipClickHijack();

	// disable gestures and main screen animations to speed up IE performance
	var isIe = window.document.documentMode; //eslint-disable-line
	if (isIe) {
		$mdGestureProvider.disableAll();
		$animateProvider.customFilter(function() {
			return false;
		});
	}
})
.config(['$provide', function($provide) {
	// Monkey patch Angular Material chips directive to fix bugs with A11y
	$provide.decorator('mdChipDirective', ['$delegate', function($delegate) {
		var originalLinkFn = $delegate[0].link;
		
		$delegate[0].compile = function() {
			return function newLinkFn(scope, element, attr, ctrls) {
				var chipsController = ctrls[0];
				var chipController = ctrls[1];
				var chipContentElement = angular.element(element[0].querySelector('.md-chip-content'));
				
				// Fix bug where focus is not reset to the chips wrapper when tabbing from a chip
				if ((chipsController) && (chipsController.__proto__)) {
					chipsController.__proto__.onFocus = function() {
						var input = this.$element[0].querySelector('input');
						if (input) {
							input.focus();
						} else {
							var wrapper = this.$element[0].querySelector('md-chips-wrap');
							if (wrapper) wrapper.focus();
						}
						this.resetSelectedChip();
					};
				}
				
				originalLinkFn.apply($delegate[0], arguments);
				
				// Fix bug with using arrow keys on a read-only chips control
				if ((chipsController) && (chipController) && (chipContentElement)) {
					chipContentElement.on('focus', function() {
						// Only execute for read-only chips, as the bug only affects those
						// (We only use read-only chips at the moment)
						if (chipsController.readonly && chipController.$scope
							&& (angular.isDefined(chipController.$scope.$index))) {
							chipsController.selectChip(chipController.$scope.$index);
							chipsController.$scope.$applyAsync();
						}
					});
				}
			};
		};

		return $delegate;
	}]);
}]);
